// extracted by mini-css-extract-plugin
export default {"wrapper":"breadcrumb_wrapper__klYlV","item":"breadcrumb_item__avHPW"};